import React from 'react';
import { Button, Tooltip } from 'antd';

export enum ModalState {
  Hidden = 'Hidden',
  View = 'View',
  Edit = 'Edit',
  New = 'New',
}

export type ActionDefinition<T> = {
  key: string;
  title: string | React.ReactNode;
  icon: React.ReactNode;
  type: 'destructive' | 'primary' | 'secondary';
  handler: (obj?: T) => void;
  canRender: (obj: T) => boolean;
  disabled?: boolean;
  loading?: boolean;
};

export function renderActionButtons<T>(obj: T, modalActions: ActionDefinition<T>[]) {
  const actions: React.ReactNode[] = [];

  const filteredActions = modalActions.filter((action) => action.canRender(obj));
  const tooManyActions = filteredActions.length > 2;

  filteredActions.forEach((action) => {
    const button = (
      <Button key={`modal-action-${action.key}`} icon={action.icon} onClick={() => action.handler(obj)} danger={action.type === 'destructive'} type={action.type === 'primary' ? 'primary' : 'default'}>
        {tooManyActions ? '' : action.title}
      </Button>
    );

    if (filteredActions) {
      actions.push(
        <Tooltip key={`modal-tooltip-action-${action.key}`} title={action.title}>
          {button}
        </Tooltip>,
      );
    } else {
      actions.push(button);
    }
  });

  return actions;
}
